import type { EmptyObject } from "@sveabank/cc-common";
import type { SelectedAddonsRecord } from "../../components/review-section/product-section";
import type { Guarantor, GuarantorInteractive } from "../../types/guarantor";
import type { SelectedProduct } from "../../types/product";
import type { Signer, Signstatus } from "../../types/signing";

export const getSelectedAddonsForReview = (products: SelectedProduct[]) =>
	products
		.filter((product) => product.isAddon && product.productDefinitionId !== "BANKGIRO")
		.reduce<SelectedAddonsRecord | EmptyObject>((acc, curr) => {
			const definitionId = curr.productDefinitionId;

			acc[definitionId] = !acc[definitionId]
				? { count: 1, product: curr }
				: {
						...acc[definitionId],
						count: acc[definitionId].count + 1,
					};

			return acc;
		}, {});

export const filterCheckedGuarantors = (possibleGuarantors: GuarantorInteractive[]) =>
	possibleGuarantors.filter((guarantor) => guarantor.checked);

export const transformGuarantorsToSigner = (guarantors: Guarantor[]) => {
	const newGuarantors: Signer[] = guarantors.map((guarantor) => ({
		firstName: guarantor.names.firstNames,
		lastName: guarantor.names.lastNames,
		nationalId: guarantor.nationalId,
		accepted: guarantor.accepted,
		email: guarantor.email,
	}));
	return newGuarantors;
};

export const checkSignatorSigningStatus = (signer: Signer, statusArray: Signstatus[]) =>
	statusArray.find((signator) => signator.nationalId === signer.nationalId)?.isSigned || false;
